import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-categorySlider"
}
const _hoisted_2 = { class: "c-categorySlider__container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

import { SliderTrack, SliderElement } from "@qd/vue-slider";

type Props = {
	categories?: Array;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySlider',
  props: {
    categories: {}
  },
  setup(__props: any) {

const props = __props;

function hasImage(imageUrl) {
	return imageUrl.length;
}

return (_ctx: any,_cache: any) => {
  return (_ctx.categories.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_unref(SliderTrack), {
            key: 'categoryslider-id',
            "slider-id": 'categoryslider-id',
            "overflow-direction": "both",
            "snap-to-grid": true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (slide, index) => {
                return (_openBlock(), _createBlock(_unref(SliderElement), {
                  key: slide.id,
                  "slider-id": 'categoryslider-id',
                  index: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: slide.url,
                      class: "category"
                    }, [
                      (slide.iconUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: slide.iconUrl
                          }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(slide.title), 1)
                    ], 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              }), 128))
            ]),
            _: 1
          }))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})